import { RuleIcon, RulePreview } from '@carboncopyco/editor-ui';
import { LinkIcon, TextOutlineIcon } from '@carboncopyco/icons';
import {
  type FindReplaceRule,
  IFindAndReplaceRuleType,
} from '@carboncopyco/types';
import { TextBase } from '@carboncopyco/ui';
import { Layout, type LayoutProps } from './Layout';

export interface ReplaceTextPreviewProps extends Pick<LayoutProps, 'layout'> {
  oldValue: string;
  newValue: string;
  type: FindReplaceRule['type'];
}

export const ReplaceValuePreview = ({
  oldValue,
  newValue,
  type,
  layout,
}: ReplaceTextPreviewProps) => {
  return (
    <RulePreview>
      <RuleIcon>
        {type === IFindAndReplaceRuleType.replaceLink ? (
          <LinkIcon />
        ) : (
          <TextOutlineIcon />
        )}
      </RuleIcon>
      <Layout layout={layout}>
        <Text value={oldValue} />
        <RulePreview.Arrow />
        <Text value={newValue} />
      </Layout>
    </RulePreview>
  );
};

const Text = ({ value }: { value: string }) => {
  return (
    <RulePreview.Tooltip title={value}>
      <div className="truncate max-w-[200px]">
        <TextBase
          label={value}
          color="text-ds-natural-600"
          ellipsis
        />
      </div>
    </RulePreview.Tooltip>
  );
};
